// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"Page-module--pageContainer--YKcfN","picture":"Page-module--picture--1r9gn"};